import { render, staticRenderFns } from "./ScheduleItem.vue?vue&type=template&id=587d5b1b&scoped=true"
import script from "./ScheduleItem.vue?vue&type=script&lang=js"
export * from "./ScheduleItem.vue?vue&type=script&lang=js"
import style0 from "./ScheduleItem.vue?vue&type=style&index=0&id=587d5b1b&prod&lang=scss&scoped=true"
import style1 from "./ScheduleItem.vue?vue&type=style&index=1&id=587d5b1b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587d5b1b",
  null
  
)

export default component.exports